import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-top-nav',
  template: `<!DOCTYPE html>
<html>
<head>
<meta name="viewport" content="width=device-width, initial-scale=1">

</head>
<body>

<div class="topnav">
   <img src="assets/images/jci logo black and white.png" width="120" height="40" alt="">
  <div class="topnav-right">
    <a href="#search">Home</a>
    <a href="#about">About</a>
    <a href="#Bruce Banner" class="fa fa-user-o" ></a>
  </div>
</div>



</body>
</html>
`,
  styles: [`html{margin:0;padding:0}body{margin:0;padding:0;font-family:Arial,Helvetica,sans-serif}.topnav{overflow:hidden;position:relative;background-color:#080000}.topnav a{float:left;color:#f2f2f2;text-align:center;padding:14px 16px;text-decoration:none;font-size:17px}.topnav a:hover{background-color:#ddd;color:#000}.topnav a.active{background-color:#4caf50;color:#fff}.topnav-right{float:right}.bg-dark{background-color:#00050b!important}img{border-style:none;top:0;left:10px;position:absolute;bottom:10px;margin-top:5px;padding-left:5px}a{color:#8b929a;text-decoration:none;background-color:transparent;padding-top:15px}a[_ngcontent-c3]{color:#8b929a;text-decoration:none;background-color:transparent;padding-top:15px;font-style:normal}`]
})
export class TopNavComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
